import { Response as MirageResponse } from 'miragejs'
import { createMockServer } from '@/api/mock-server/server.js'

declare global {
  interface Window {
    MirageResponse?: typeof MirageResponse
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (!config.public.isTest) {
    createMockServer({ environment: process.env.NODE_ENV })
    return
  }

  // mirage does not load development seeds if its `environment` option is set to 'test'.
  // see: https://miragejs.com/docs/testing/application-tests/#the-test-environment
  // this also exposes the mock server on window.server
  createMockServer({ environment: 'test' })

  // we need this globally exposed for tests
  window.MirageResponse = MirageResponse
  window.dispatchEvent(new Event('mirage:ready'))
})
